module.exports = __webpack_public_path__ + "img/453db4e.svg";